import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const scannerDeleteAtom = createMutationAtomFactory(
  'settings.scannerDelete',
  (params: { id: string }) => ({
    iotScannerDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
